import api from './api';

/**
 * API para el módulo de Biblia de Estudio
 */

// ==================== VERSIONES DE BIBLIAS ====================

export const getVersions = async () => {
  try {
    const response = await api.get('/bible/versions');
    return response.data;
  } catch (error) {
    console.error('Error al obtener versiones:', error);
    throw error;
  }
};

export const getVersion = async (versionId) => {
  try {
    const response = await api.get(`/bible/versions/${versionId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener versión:', error);
    throw error;
  }
};

// ==================== LECTURA DE BIBLIAS ====================

export const getBooks = async (versionId) => {
  try {
    const response = await api.get(`/bible/versions/${versionId}/books`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener libros:', error);
    throw error;
  }
};

export const getChapter = async (versionId, book, chapter) => {
  try {
    const response = await api.get(`/bible/versions/${versionId}/${book}/${chapter}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener capítulo:', error);
    throw error;
  }
};

export const getVerses = async (versionId, book, chapter, verseStart, verseEnd = null) => {
  try {
    const url = verseEnd 
      ? `/bible/versions/${versionId}/${book}/${chapter}/${verseStart}/${verseEnd}`
      : `/bible/versions/${versionId}/${book}/${chapter}/${verseStart}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener versículos:', error);
    throw error;
  }
};

export const getParallelVerses = async (versionIds, book, chapter, verseStart, verseEnd = null) => {
  try {
    const response = await api.post('/bible/parallel', {
      versionIds,
      book,
      chapter,
      verseStart,
      verseEnd
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener versiones paralelas:', error);
    throw error;
  }
};

// ==================== BÚSQUEDA ====================

export const searchByStrong = async (versionId, strongNumber) => {
  try {
    const response = await api.get(`/bible/versions/${versionId}/search/strong/${strongNumber}`);
    return response.data;
  } catch (error) {
    console.error('Error al buscar por Strong:', error);
    throw error;
  }
};

export const searchWord = async (versionId, word, caseSensitive = false) => {
  try {
    const response = await api.get(`/bible/versions/${versionId}/search/word`, {
      params: { word, caseSensitive }
    });
    return response.data;
  } catch (error) {
    console.error('Error al buscar palabra:', error);
    throw error;
  }
};

// ==================== DICCIONARIO STRONG ====================

export const getStrongDefinition = async (strongNumber) => {
  try {
    const response = await api.get(`/bible/dictionary/strong/${strongNumber}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener definición Strong:', error);
    throw error;
  }
};

// ==================== HIGHLIGHTS (SUBRAYADOS) ====================

export const createHighlight = async (highlightData) => {
  try {
    const response = await api.post('/bible/highlights', highlightData);
    return response.data;
  } catch (error) {
    console.error('Error al crear highlight:', error);
    throw error;
  }
};

export const getHighlights = async (book = null, chapter = null) => {
  try {
    const params = {};
    if (book) params.book = book;
    if (chapter) params.chapter = chapter;
    const response = await api.get('/bible/highlights', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener highlights:', error);
    throw error;
  }
};

export const updateHighlight = async (id, highlightData) => {
  try {
    const response = await api.put(`/bible/highlights/${id}`, highlightData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar highlight:', error);
    throw error;
  }
};

export const deleteHighlight = async (id) => {
  try {
    const response = await api.delete(`/bible/highlights/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar highlight:', error);
    throw error;
  }
};

// ==================== NOTAS ====================

export const createNote = async (noteData) => {
  try {
    const response = await api.post('/bible/notes', noteData);
    return response.data;
  } catch (error) {
    console.error('Error al crear nota:', error);
    throw error;
  }
};

export const getNotes = async (filters = {}) => {
  try {
    const response = await api.get('/bible/notes', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error al obtener notas:', error);
    throw error;
  }
};

export const getNote = async (id) => {
  try {
    const response = await api.get(`/bible/notes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener nota:', error);
    throw error;
  }
};

export const updateNote = async (id, noteData) => {
  try {
    const response = await api.put(`/bible/notes/${id}`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar nota:', error);
    throw error;
  }
};

export const deleteNote = async (id) => {
  try {
    const response = await api.delete(`/bible/notes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar nota:', error);
    throw error;
  }
};

export const searchNotes = async (query) => {
  try {
    const response = await api.get('/bible/notes/search', { params: { query } });
    return response.data;
  } catch (error) {
    console.error('Error al buscar notas:', error);
    throw error;
  }
};

// ==================== RELACIONES DE ESTUDIO ====================

export const createRelation = async (relationData) => {
  try {
    const response = await api.post('/bible/relations', relationData);
    return response.data;
  } catch (error) {
    console.error('Error al crear relación:', error);
    throw error;
  }
};

export const getRelations = async (filters = {}) => {
  try {
    const response = await api.get('/bible/relations', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error al obtener relaciones:', error);
    throw error;
  }
};

export const getRelation = async (id) => {
  try {
    const response = await api.get(`/bible/relations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener relación:', error);
    throw error;
  }
};

export const updateRelation = async (id, relationData) => {
  try {
    const response = await api.put(`/bible/relations/${id}`, relationData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar relación:', error);
    throw error;
  }
};

export const deleteRelation = async (id) => {
  try {
    const response = await api.delete(`/bible/relations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar relación:', error);
    throw error;
  }
};

export const searchParentRelations = async (query, relationTypeId = null) => {
  try {
    const params = {};
    if (query) params.query = query;
    if (relationTypeId) params.relationTypeId = relationTypeId;
    const response = await api.get('/bible/relations/search-parents', { params });
    return response.data;
  } catch (error) {
    console.error('Error al buscar relaciones padre:', error);
    throw error;
  }
};

export const getRelationTree = async (id) => {
  try {
    const response = await api.get(`/bible/relations/${id}/tree`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener árbol de relación:', error);
    throw error;
  }
};

// ==================== CATÁLOGOS ====================

export const getRelationTypes = async () => {
  try {
    const response = await api.get('/bible/catalogs/relation-types');
    return response.data;
  } catch (error) {
    console.error('Error al obtener tipos de relaciones:', error);
    throw error;
  }
};

export const getApplicationGroups = async () => {
  try {
    const response = await api.get('/bible/catalogs/application-groups');
    return response.data;
  } catch (error) {
    console.error('Error al obtener grupos de aplicación:', error);
    throw error;
  }
};

export const getApplicationPlaces = async () => {
  try {
    const response = await api.get('/bible/catalogs/application-places');
    return response.data;
  } catch (error) {
    console.error('Error al obtener lugares de aplicación:', error);
    throw error;
  }
};

export const getApplicationTimes = async () => {
  try {
    const response = await api.get('/bible/catalogs/application-times');
    return response.data;
  } catch (error) {
    console.error('Error al obtener tiempos de aplicación:', error);
    throw error;
  }
};

export const getPunishmentTypes = async () => {
  try {
    const response = await api.get('/bible/catalogs/punishment-types');
    return response.data;
  } catch (error) {
    console.error('Error al obtener tipos de castigo:', error);
    throw error;
  }
};

// Exportar todo como objeto por defecto también
export default {
  // Versiones
  getVersions,
  getVersion,
  
  // Lectura
  getBooks,
  getChapter,
  getVerses,
  getParallelVerses,
  
  // Búsqueda
  searchByStrong,
  searchWord,
  
  // Diccionario
  getStrongDefinition,
  
  // Highlights
  createHighlight,
  getHighlights,
  updateHighlight,
  deleteHighlight,
  
  // Notas
  createNote,
  getNotes,
  getNote,
  updateNote,
  deleteNote,
  searchNotes,
  
  // Relaciones
  createRelation,
  getRelations,
  getRelation,
  updateRelation,
  deleteRelation,
  searchParentRelations,
  getRelationTree,
  
  // Catálogos
  getRelationTypes,
  getApplicationGroups,
  getApplicationPlaces,
  getApplicationTimes,
  getPunishmentTypes
};

